import type { Classification } from '@seek/ca-myprofile-utils';

import type { Location, Maybe } from 'src/types';
import type * as Schema from 'src/types/graphql';

import type { RightToWork } from './RightToWork/types';
import type { WorkType } from './WorkTypes/types';

export const emptyRolePreference = ({
  preferredLocations,
  preferredClassification,
  workTypes,
  rightsToWork,
  availability,
  salaryPreferences,
}: {
  salaryPreferences: Schema.SalaryPreference2[];
  rightsToWork: RightToWork[];
  preferredLocations: Location[] | Schema.Location2[];
  preferredClassification: Maybe<Classification>;
  availability: Maybe<Schema.Availability>;
  workTypes: WorkType[];
}) => {
  const hasAvailability = Boolean(availability);
  const hasClassification = Boolean(preferredClassification);
  const hasPreferredLocations = preferredLocations.length > 0;
  const hasWorkTypes = workTypes.length > 0;
  const hasSalary =
    salaryPreferences.filter(
      (salaryPreference) => salaryPreference.amount !== null,
    ).length > 0;
  const hasRightToWork = rightsToWork.filter((rtw) => rtw.type2).length > 0;

  return !(
    hasClassification ||
    hasPreferredLocations ||
    hasAvailability ||
    hasWorkTypes ||
    hasSalary ||
    hasRightToWork
  );
};
